var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWinredShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "177px",
    height: "197px",
    viewBox: "0 0 177 197",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WinRed-mark-red") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "100%",
    fx: "50%",
    fy: "100%",
    r: "110.467026%",
    gradientTransform: "translate(0.500000,1.000000),scale(1.000000,0.905248),rotate(-90.000000),translate(-0.500000,-1.000000)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0021B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0021B",
    offset: "50.6706105%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003061",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.52926925,-6.0017597e-06 L145.058913,-6.07854364e-06 C148.664929,-6.07854364e-06 151.588182,2.92324734 151.588182,6.52926318 C151.588182,6.52926318 151.588182,6.52926325 151.588182,6.52926325 L151.58815,112.47342 C151.58815,133.677692 134.398691,150.867151 113.194419,150.867151 C113.194419,150.867151 113.194419,150.867151 113.194419,150.867151 C88.2017467,150.867151 75.7349711,155.377306 75.7940921,164.397616 C75.7349711,155.377306 63.2398337,150.867151 38.30868,150.867151 C38.30868,150.867151 38.30868,150.867151 38.30868,150.867151 L38.30868,150.867151 C17.1514066,150.867151 4.71276953e-05,133.715793 4.51726204e-05,112.558519 L2.66453526e-14,6.52926325 C-3.33220177e-07,2.92324742 2.92325281,-6.27188799e-06 6.52926865,-6.60510819e-06 C6.52926886,-6.60510821e-06 6.52926905,-6.60510822e-06 6.52926925,-6.60510822e-06 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Marketing-Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WinRed-mark-red"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.635084, 0.937984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-53",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4113847,0 L158.860364,-1.04277547e-07 C168.476406,-1.04277548e-07 176.271748,7.79534234 176.271748,17.4113846 L176.2717,131.349892 C176.2717,155.763211 156.480794,175.554117 132.067475,175.554117 C132.067475,175.554117 132.067475,175.554117 132.067475,175.554117 C102.597961,175.554117 87.9540934,182.372147 88.1358736,196.008208 C89.3624312,182.372147 74.9797583,175.554117 44.987855,175.554117 C44.987855,175.554117 44.987855,175.554117 44.987855,175.554117 L44.987855,175.554117 C20.1417337,175.554117 -2.72931779e-05,155.412356 -2.72931781e-05,130.566234 L3.55271368e-15,17.4113847 C-7.0221382e-14,7.79534245 7.79534245,-5.78051646e-14 17.4113847,-1.27897692e-13 Z",
    id: "Rectangle"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(6.229651, 6.232394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-2",
    fill: "url(#radialGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8821406,6.28853122e-05 L153.511479,6.22651459e-05 C159.521505,6.22651459e-05 164.393594,4.87215129 164.393594,10.8821777 L164.393608,120.854805 C164.393607,143.850335 145.752046,162.491895 122.756515,162.491895 C95.65259,162.491895 82.132685,168.861513 82.1968002,181.600749 C82.132685,168.861513 68.5820223,162.491895 41.5448123,162.491895 C18.6002666,162.491895 3.73084445e-05,143.891666 3.73084421e-05,120.94712 L2.51992062e-05,10.8821783 C2.51992055e-05,4.87215191 4.87211423,6.28853117e-05 10.8821406,6.2885311e-05 Z M12.4262032,3.46406502 C7.6181821,3.46406502 3.72051087,7.36173625 3.72051087,12.1697574 L3.72053102,120.432132 C3.72053102,142.149065 21.3255838,159.754118 43.042517,159.754118 C69.0836194,159.754118 82.1350471,165.189172 82.1968002,176.05928 C82.1350471,165.189172 95.1568504,159.754118 121.26221,159.754118 C143.02822,159.754118 160.673058,142.109281 160.673059,120.34327 L160.673105,12.169757 C160.673105,7.36173591 156.775434,3.46406469 151.967413,3.46406469 L12.4262032,3.46406502 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-76",
    transform: "translate(6.229651, 6.232394)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#003061",
    fillRule: "nonzero",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.990028, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#003061",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 155.359545,
    height: 76.0975854
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-50",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(17.304587, 21.467136)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Star",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "16.2993053 24.4680107 6.71881403 29.5086982 8.54852506 18.8323509 0.797744785 11.2713197 11.5090597 9.71366166 16.2993053 0 21.089551 9.71366166 31.8008659 11.2713197 24.0500856 18.8323509 25.8797966 29.5086982"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "60.2722258 24.4680107 50.6917345 29.5086982 52.5214455 18.8323509 44.7706652 11.2713197 55.4819801 9.71366166 60.2722258 0 65.0624714 9.71366166 75.7737863 11.2713197 68.023006 18.8323509 69.8527171 29.5086982"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "104.245146 24.4680107 94.6646549 29.5086982 96.4943659 18.8323509 88.7435857 11.2713197 99.4549006 9.71366166 104.245146 0 109.035392 9.71366166 119.746707 11.2713197 111.995926 18.8323509 113.825637 29.5086982"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-51",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0.865229, 76.200283)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 106.443602,
    y: 0,
    width: 11.7293225,
    height: 101.003116
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D0021B",
    fillRule: "nonzero",
    x: 118.270669,
    y: 0,
    width: 11.7293225,
    height: 101.003116
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 130.097736,
    y: 0,
    width: 11.7293225,
    height: 101.003116
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D0021B",
    fillRule: "nonzero",
    x: 141.924803,
    y: 0,
    width: 11.7293225,
    height: 101.003116
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D0021B",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 11.7293225,
    height: 101.003116
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 11.8270669,
    y: 0,
    width: 11.7293225,
    height: 101.003116
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D0021B",
    fillRule: "nonzero",
    x: 23.6541338,
    y: 0,
    width: 11.7293225,
    height: 101.003116
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 35.4812006,
    y: 0,
    width: 11.7293225,
    height: 101.003116
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D0021B",
    fillRule: "nonzero",
    x: 47.3082675,
    y: 0,
    width: 11.7293225,
    height: 101.003116
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 59.1353344,
    y: 0,
    width: 11.7293225,
    height: 101.003116
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D0021B",
    fillRule: "nonzero",
    x: 70.9624013,
    y: 0,
    width: 11.7293225,
    height: 101.003116
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 82.7894682,
    y: 0,
    width: 11.7293225,
    height: 101.003116
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D0021B",
    fillRule: "nonzero",
    x: 94.6165351,
    y: 0,
    width: 11.7293225,
    height: 101.003116
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinredShield);
export default __webpack_public_path__ + "static/media/winred-shield.b355306a7b9a7f22c927c728d7f13fbe.svg";
export { ForwardRef as ReactComponent };